import { render, staticRenderFns } from "./ContentFeedContent.vue?vue&type=template&id=25c50202&scoped=true"
import script from "./ContentFeedContent.vue?vue&type=script&lang=js"
export * from "./ContentFeedContent.vue?vue&type=script&lang=js"
import style0 from "./ContentFeedContent.vue?vue&type=style&index=0&id=25c50202&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c50202",
  null
  
)

export default component.exports